import React from "react";
import { RenderIf } from "shared/components";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import "./Index.scss";

const Input = React.forwardRef(
  (
    {
      type,
      placeholder,
      name,
      value,
      disabled,
      accept,
      readOnly,
      onChange,
      label,
      required,
      searchButton,
      min,max,
      id,
      defaultValue,
      className,
      errorMessage,
      isPasswordInput,
    },
    ref
  ) => {    
    const [showPassword, setShowPassword] = React.useState(false);

    const handleEnter = (e) => {
      if (e.key.toLowerCase() === "enter") {
        e.preventDefault();
        const next = [...e.target.form].indexOf(e.target) + 1;
        e.target.form.elements[next]?.focus();
      }
    };

    const togglePassword = () => {
      setShowPassword((prev) => !prev);
    };
  const handleChange = (e) => {
      let val = e.target.value;
      if (type === "number") {
        if (val === "") val = "";
        else {
          val = Number(val);
          if (max !== undefined && val > max) val = max;
          if (min !== undefined && val < min) val = min;
        }
      }
      onChange({ target: { name: e.target.name, value: val } });
    };
    return (
      <div className="inputs">
        <RenderIf condition={label}>
          <label className="font-500">
            <RenderIf condition={required} renderElse={<>{label}</>}>
              <>
                {label}
                <span className="text-danger" style={{ fontWeight: 600 }}>
                  *
                </span>
              </>
            </RenderIf>
          </label>
        </RenderIf>

        <div style={{ position: "relative" }}>
          <input
            max={type === "number" ? max : undefined}
            min={type === "number" ? min : undefined}
            className={`${searchButton ? `padding` : ""} ${
              className ? className : ""
            }`}
            placeholder={placeholder}
            name={name}
            id={id}
            accept={accept}
            onKeyDown={handleEnter}
            ref={ref}
            type={isPasswordInput ? (showPassword ? "text" : "password") : type}
            value={value}
            defaultValue={defaultValue}
            disabled={disabled}
            readOnly={readOnly}
            onChange={handleChange}
            autoComplete="new-password"
            style={{
              backgroundColor: disabled ? "hsl(0, 0%, 95%)" : "#ffff",
              cursor: disabled ? "not-allowed" : "auto",
            }}
          />
          <RenderIf condition={isPasswordInput}>
            <div
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
              }}>
              {showPassword ? (
                <VisibilityOff onClick={togglePassword} />
              ) : (
                <Visibility onClick={togglePassword} />
              )}
            </div>
          </RenderIf>
        </div>
        <RenderIf condition={errorMessage} renderElse={null}>
          <div className="fv-plugins-message-container mt-2">
            <div className="fv-help-block">{errorMessage}</div>
          </div>
        </RenderIf>
      </div>
    );
  }
);

export default Input;
